export default "__VITE_ASSET__DbUBiuwm__"